
import TableList from "@components/templates/tablelist";
import {
    HttpGetTransplanList,
    HttpTransferPlanSubmit,
    HttpTransferPlanCancelSubmit,
    HttpTransferPlanCancel,
    HttpTransferPlanDealAgain,
    HttpGetTransferPlanNumber,
    HttpTransferPlanIgonreError
} from "@/service/transferplan";
import { mapState, mapGetters } from "vuex";
import mixin from "./mixin";
import ajaxmixin from "./ajaxmixin";
import compUpdate from "./update";
import compDelivery from "./alert/delivery";
import compAddByInbound from "./alert/addbyinbound";
export default {
    mixins: [TableList, mixin, ajaxmixin],
    components: {
        compDelivery,
        compAddByInbound,
        compUpdate
    },
    data() {
        return {
            // totals: 0,
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {
                search: {
                }
            },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: { show: true },
            spanTabs: { show: true },
        };
    },
    async created() {

    },
    methods: {
        ajaxRequest: HttpGetTransplanList,
        spanAjaxRequest: () => {
            return HttpGetTransferPlanNumber({
                isManage: false
            })
        },
        interceptRequest(params) {
            let data = this.handleParams(params);
            return {
                ...data,
                isManage: false
            }
        },
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning(this.$t('global.common.choose_one', { defaultValue: '请选择至少一条数据' }));
            }
            switch (type) {
                case "add":
                    this.$router.push({
                        name: 'transferPlanUpdate',
                        params: { type: "add" },
                        // query: { id: params },
                    });
                    break;
                case "edit":
                    {
                        let url = this.$router.resolve({
                            name: 'transferPlanUpdate',
                            params: { type: "edit" },
                            query: { id: params },
                        });
                        window.open(url.href, '_blank');
                    }
                    break;
                case "query":
                    this.operate = {
                        title: this.$t('global.common.query', { defaultValue: '查看' }),
                        show: true,
                        width: 1200,
                        component: "compUpdate",
                        activeid: params,
                        querytype: 'query',
                        showFooter: false
                    }
                    break;
                case "queryBlank":
                    var url = this.$router.resolve({
                        name: "transferPlanUpdate",
                        params: { type: "query" },
                        query: { id: params },
                    });
                    window.open(url.href, '_blank');
                    break;
                case "submitbox":
                    this.operate = {
                        show: true,
                        alert: "primary",
                        title: this.$t('global.common.update_submit', { defaultValue: "提交" }),
                        width: 460,
                        params: {
                            id: params
                        },
                        ajaxRequest: HttpTransferPlanSubmit
                    };
                    break;
                case "cancel":
                    this.operate = {
                        show: true,
                        alert: "warning",
                        title: this.$t('global.common.operate_cancel', { defaultValue: "取消" }),
                        width: 460,
                        showDesc: false,
                        params: {
                            id: params
                        },
                        formdata: [
                            {
                                tag: "vTextarea",
                                key: "remark",
                                span: 24,
                                label: "取消原因",
                            }
                        ],
                        ajaxRequest: HttpTransferPlanCancel,
                    };
                    break;
                case 'export':
                    let data = this.handleParams(this.formData);
                    data.isManage = false;
                    this.handleWebfs(process.env.VUE_APP_APIURL_FBB + "/api/v2/Transit/batchExport",
                        data
                        , {
                            executor: 'request',
                            download: true,
                        }).catch(err => {
                            this.$VMessage.error(err.message);
                        })
                    break;
                case 'batchDelivery':
                    this.operate = {
                        title: "确认发货",
                        show: true,
                        width: 1200,
                        activeid: params,
                        showFooter: false,
                        component: "compDelivery",
                        isEdit: true
                    };
                    break;
                case 'addInbound':
                    this.operate = {
                        title: "从入库计划添加",
                        show: true,
                        width: 1200,
                        showFooter: false,
                        component: "compAddByInbound"
                    }
                    break;
                case 'submitAudit':
                    this.operate = {
                        title: "提交审核",
                        alert: "warning",
                        show: true,
                        params: {
                            id: params
                        },
                        ajaxRequest: HttpTransferPlanSubmit,
                        showFooter: true
                    };
                    break;
                case 'cancelAudit':
                    this.operate = {
                        title: "撤销审核",
                        alert: "warning",
                        show: true,
                        params: {
                            id: params
                        },
                        ajaxRequest: HttpTransferPlanCancelSubmit,
                        showFooter: true
                    };
                    break;
                case 'dealAgain':
                    this.operate = {
                        title: "重处理",
                        alert: "warning",
                        show: true,
                        params: {
                            id: params
                        },
                        ajaxRequest: HttpTransferPlanDealAgain,
                        showFooter: true
                    };
                    break;
                case 'ignoreError':
                    this.operate = {
                        title: "忽略异常",
                        alert: "warning",
                        show: true,
                        params: {
                            id: params
                        },
                        ajaxRequest: HttpTransferPlanIgonreError,
                        showFooter: true
                    };
                    break;
            }
        },
        getOperateNodeMap(row) {
            const { id, status, errorStatus } = row
            return [
                {
                    label: this.$t('global.common.query', { defaultValue: '查看' }),
                    show: this.handleAuth('fbb.transferplan.view'),
                    params: id,
                    operate: 'query'
                },
                {
                    label: this.$t('global.common.edit', { defaultValue: '编辑' }),
                    show: (status == 0 || status == 6) && this.handleAuth('fbb.transferplan.edit'),
                    params: id,
                    operate: 'edit'
                },
                {
                    label: "提交审核",
                    show: (status == 0 || status == 6) && this.handleAuth('fbb.transferplan.edit'),
                    params: id,
                    operate: 'submitbox'
                },
                {
                    label: "撤销审核",
                    show: status == 5 && this.handleAuth('fbb.transferplan.edit'),
                    params: id,
                    operate: "cancelAudit"
                },
                {
                    label: "确认发货",
                    show: status == 10 && this.handleAuth('fbb.transferplan.edit'),
                    params: [id],
                    operate: "batchDelivery",
                },
                {
                    label: "重处理",
                    show: errorStatus < 99999,
                    params: id,
                    operate: "dealAgain"
                },
                {
                    label: this.$t('global.common.operate_cancel', { defaultValue: '取消' }),
                    show: status <= 15 && this.handleAuth('fbb.transferplan.edit'),
                    params: id,
                    operate: 'cancel'
                },
                {
                    label: "忽略异常",
                    show: errorStatus < 99999,
                    params: id,
                    operate: "ignoreError"
                },
            ]
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getProductList', 'getSystemPortList', 'getCompanyList', 'getFilterDisabledWarehouse']),
        choseOrderStatusList() {
            return this.orderStatusList.filter(item => {
                return item.value != 10
            })
        },
        TabsData() {
            return [
                {
                    name: this.$t('global.common.all', { defaultValue: '全部' }),
                    key: 'EQ_status',
                    val: null,
                    spanKey: "allQty"
                },
                {
                    name: '草稿',
                    key: 'EQ_status',
                    val: 0,
                    spanKey: "deaftQty"
                },
                {
                    name: this.$t('fbb.headlogistics.daishenhe', { defaultValue: '待审核' }),
                    key: 'EQ_status',
                    val: 5,
                    spanKey: "unApprovedQty"
                },
                {
                    name: '审核拒回',
                    key: 'EQ_status',
                    val: 6,
                    spanKey: "refusedQty"
                },
                {
                    name: '待发货',
                    key: 'EQ_status',
                    val: 10,
                    spanKey: "unShippedQty"
                },
                {
                    name: '待入库',
                    key: 'EQ_status',
                    val: 15,
                    spanKey: "unReceivedQty"
                },
                {
                    name: '待出库',
                    key: 'EQ_status',
                    val: 25,
                    spanKey: "unOutboundQty"
                },
                {
                    name: '已完成',
                    key: 'EQ_status',
                    val: 70,
                    spanKey: "completedQty"
                },
                {
                    name: '异常',
                    key: 'LE_errorStatus',
                    val: 99998,
                    spanKey: "errorQty"
                }
            ]
        },
        ToolsData() {
            return [
                {
                    name: this.$t('global.common.add', { defaultValue: "添加" }),
                    operate: "add",
                    theme: "primary",
                    show: this.handleAuth('fbb.transferplan.edit')
                },
                {
                    name: this.$t('global.common.export', { defaultValue: '导出' }),
                    operate: 'export',
                    show: this.handleAuth('fbb.transferplan.export'),
                    theme: 'primary'
                },
                {
                    name: '从入库计划添加',
                    operate: 'addInbound',
                    show: this.handleAuth('fbb.transferplan.addfrominbound'),
                    more: true
                },
                {
                    name: '批量确认发货',
                    operate: 'batchDelivery',
                    show: this.handleAuth('fbb.transferplan.edit'),
                    batch: true,
                    more: true
                }
            ]
        },
        SearchsData() {
            let widthStyle = 'width: 220px;'
            return [
                {
                    label: '转运计划单号',
                    tag: 'vInput',
                    key: 'EQ_transitPlanOrderNo',
                    show: true,
                    style: 'width: 130px;'
                },
                {
                    label: '来源单号',
                    tag: 'vInput',
                    key: 'EQ_sourceNo',
                    show: true,
                    style: 'width: 130px;'
                },
                {
                    label: this.$t('fbb.headlogistics.order_status', { defaultValue: "单据状态" }),
                    tag: 'Select',
                    key: 'IN_status',
                    show: true,
                    options: this.getStatus,
                    props: {
                        filterable: true,
                        multiple: true
                    },
                    style: 'width: 130px;'
                },
                {
                    label: this.$t('global.common.line', { defaultValue: '项目' }),
                    key: 'IN_lineId',
                    tag: 'Select',
                    options: this.getProductList,
                    props: {
                        filterable: true,
                        multiple: true
                    },
                    style: widthStyle
                },
                {
                    label: '转运仓库',
                    key: 'IN_orgWarehouseId',
                    tag: 'Select',
                    options: this.mixinWarehouseList,
                    props: {
                        multiple: true,
                        filterable: true
                    },
                    style: widthStyle
                },
                {
                    label: '目的地',
                    tag: 'Select',
                    key: 'IN_receiveCode',
                    options: this.mixinDestinationList,
                    props: {
                        filterable: true,
                    },
                    style: widthStyle
                },
                {
                    // label: this.$t('fbb.headlogistics.logistics_number', { defaultValue: "物流单号/提单号" }),
                    label: `${this.$t('fbb.headlogistics.logistics_number_logistics', { defaultValue: '物流单号' })}`,
                    tag: 'vInput',
                    key: 'EQ_tmsNo',
                    style: widthStyle
                },
                {
                    label: 'Shipment ID',
                    tag: 'vInput',
                    key: 'EQ_shipmentId',
                    // default:this.initData,
                    style: widthStyle
                },
                {
                    label: 'Reference ID',
                    tag: 'vInput',
                    key: 'EQ_referenceId',
                    style: widthStyle
                },
                {
                    label: this.$t('fbb.headlogistics.container_number', { defaultValue: "集装箱号" }),
                    tag: 'vInput',
                    key: 'CN_CartonNo',
                    style: widthStyle
                },
                {
                    label: "预计到仓日期",
                    key: "BT_estimateArriveTime",
                    tag: "vDatepicker",
                    props: {
                        format: 'yyyy-mm-dd ~ yyyy-mm-dd',
                        confirm: false,
                    },
                    style: widthStyle
                },
                {
                    label: this.$t('fbb.headlogistics.exception_status', { defaultValue: "异常状态" }),
                    tag: 'Select',
                    key: 'EQ_errorStatus',
                    options: this.getExceptionStatus,
                    props: {
                        filterable: true,
                    },
                    style: widthStyle
                },
                {
                    label: '创建日期',
                    tag: 'vDatepicker',
                    key: 'BT_createdAt',
                    // default:this.initData,
                    props: {
                        format: 'yyyy-mm-dd ~ yyyy-mm-dd',
                        confirm: false,
                    },
                    style: widthStyle
                }
            ]
        },
        columns() {
            return [
                {
                    show: false,
                    type: 'selection',
                    width: 40,
                    align: 'center',
                    formName: 'id',
                    // fixed: 'left'
                }, {
                    title: this.$t('global.common.operation', { defaultValue: '操作' }),
                    width: 70,
                    render: this.getOperateNodes,
                    // fixed: 'left'
                }, {
                    title: '转运计划单号/来源单号',
                    sortable: true,
                    // fixed: 'left',
                    render: (h, { row }) => {
                        let errorItem = this.getExceptionStatus.filter(item => {
                            return item.value == row.errorStatus;
                        })[0];
                        return <div>
                            <div>
                                <a onClick={this.handleOperates.bind(this, row.id, 'query')}>{row.transitPlanOrderNo || '--'}</a>
                                <a onClick={this.handleOperates.bind(this, row.id, 'queryBlank')}><vIcon class="margin-left-10 font-14" type="ios-browsers-outline" /></a>
                            </div>
                            <div>{row.sourceNo || "--"}</div>
                            <div v-show={row.errorStatus < 99999} class="color-error">{errorItem ? errorItem.label : "未知错误"}</div>
                        </div>
                    }
                },
                {
                    title: '状态',
                    key: "status",
                    render: (h, { row }) => {
                        let statusItem = this.getStatus.filter(item => {
                            return item.value == row.status
                        })[0];
                        return <div>
                            <div class={statusItem.color}>{statusItem.label}</div>
                        </div>
                    }
                },
                {
                    title: '项目',
                    render: (h, { row }) => {
                        let lineItem = this.getProductList.filter(item => {
                            return row.lineId == item.value;
                        })[0];
                        return <div>{lineItem ? lineItem.label : '--'}</div>
                    }
                },
                {
                    title: '转运仓库/目的地',
                    render: (h, { row }) => {
                        let warehouseItem = this.mixinWarehouseList.filter(item => {
                            return row.orgWarehouseId == item.value;
                        })[0];
                        let destItem = this.mixinDestinationList.filter(item => {
                            return row.receiveCode == item.value;
                        })[0];
                        return (
                            <div>
                                <div>{warehouseItem ? warehouseItem.label : '--'}</div>
                                <div>{destItem ? destItem.label : '--'}</div>
                            </div>

                        );
                    }
                },
                {
                    title: 'Shipment ID/Reference ID',
                    render: (h, { row }) => {
                        return <div>
                            <div>{row.shipmentId || '--'}</div>
                            <div>{row.referenceId || '--'}</div>
                        </div>
                    }
                },
                {
                    title: '计划数/接收数/出库数',
                    render: (h, { row }) => {
                        return <div>
                            <div>{row.planQty || '--'}</div>
                            <div>{row.inboundQty || '--'}</div>
                            <div>{row.outboundQty || '--'}</div>
                        </div>
                    }
                },
                {
                    title: "预计到仓日期/首次接收日期",
                    render: (h, { row }) => {
                        let estimateArriveTime = row.estimateArriveTime,
                            firstReceptionDate = row.firstReceptionDate;
                        return (
                        <div>
                            <div>{estimateArriveTime || "--"}</div>
                            <div>{firstReceptionDate || "--"}</div>
                        </div>
                        )
                    }
                },
                {
                    title: this.$t('global.common.update_time', { defaultValue: '更新时间' }),
                    key: 'updatedAt',
                    width: 180,
                    // render: (h, { row }) => {
                    //     return <div>
                    //         <div>{row.updatedAt}</div>
                    //     </div>
                    // }
                },
            ];
        },

    },

};
